export const isValidURL = (string) => {
  let regex = /[A-Za-z]+:\s+/i;
  if (regex.test(string)) {
    return false;
  } else {
    try {
      const urlString = /^www\./i.test(string) ? `https://${string}` : string;
      new URL(urlString);
      return true;
    } catch (_) {
      return false;
    }
  }
};
